<template>
    <div>
        <div style="background-color: #fafafa;line-height: 49px;height: 49px;">
            <el-checkbox class="ml10" v-if="groups.length > 0" :disabled="readOnly" :indeterminate="isIndeterminate" v-model="checked" @change="handleCheckAllChange">
                <span>全选</span>
            </el-checkbox>
            <button @click="updateComRole();" style="float: right;margin-top: 8px;" class='swb-btn swb-btn-small mr15' v-if="!readOnly">
                <span>保存</span>
            </button>
        </div>
        <div v-if="groups != null" v-for="group in groups">
            <div style="margin: 5px 0;" class="content-caption dashed">
                <span><span class="color-laber"></span>{{group.name}}</span>
            </div>
            <ul v-if="group.subGroups.length > 0" class="switch-list clearfix ml10 mt10">
                <el-checkbox-group @change="handleCheckedChange" v-model="groupIds">
                    <li v-for="subGroup in group.subGroups" class="switch-item ellipsis-1" style="width: auto;margin-right: 30px;">
                        <el-checkbox :label="subGroup.id" :disabled="readOnly">
                            <span>{{subGroup.name}}</span>
                        </el-checkbox>
                    </li>
                </el-checkbox-group>
            </ul>
        </div>
        <ul v-if="groups == null || groups.length <= 0" style="margin-top: 50px;" class="switch-list clearfix ml10">
            <li class="switch-item ellipsis-1" style="width: auto;margin-right: 30px;">
                <span>暂无数据</span>
            </li>
        </ul>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import merchtAllApi from '../../api/merchtAll'
    import goodsCategApi from '../../api/goodsCateg'

    export default {
        name: 'swb-mercht-tpl-role-devc-group',
        desc: '商户模版岗位-设备分类分组',
        props: {
            roleId: {
                type: Number,
                default: null
            },
            readOnly: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                groups: [],
                groupIds: [],
                checked: false,
                isIndeterminate: false
            }
        },
        created: function () {
            this.getGroups();
        },
        methods: {
            getMerchtTplRoleDevcGroupList: function () {
                let self = this;
                let postData = {
                    tplRoleId: self.roleId,
                };
                merchtAllApi.getMerchtTplRoleDevcGroupList(postData, function (retult) {
                    if(retult.type == "info") {
                        let devcGroups = retult.data || [];
                        self.groupIds = devcGroups.pluck('groupId');
                        //
                        let sumLength = 0;
                        let groups = self.groups || [];
                        for(let i = 0; i < groups.length; i++) {
                            sumLength += groups[i].subGroups.length || 0;
                        }
                        self.checked = self.groupIds.length >= sumLength;
                        self.isIndeterminate = self.groupIds.length > 0 && self.groupIds.length < sumLength;
                    } else {
                        MsgBox.warning(retult.message);
                    }
                });
            },
            getGroups: function () {
                let self = this;
                let loading = MsgBox.loading();
                goodsCategApi.getGoodsCatDevcGroupListByCatId({}, function (result) {
                    loading.hide();
                    if(result.type == "info") {
                        let groups = result.data || [];
                        let newGroups = [];
                        for(let i = 0; i < groups.length; i++) {
                            let groupInfo = groups[i];
                            if(groupInfo.level == 1) {
                                groupInfo.subGroups = [];
                                newGroups.push(groupInfo);
                            }
                        }
                        for(let i = 0; i < groups.length; i++) {
                            let groupInfo = groups[i];
                            if(groupInfo.level == 2) {
                                for(let j = 0; j < newGroups.length; j++) {
                                    let newGroup = newGroups[j];
                                    if(newGroup.id == groupInfo.parentId) {
                                        newGroup.subGroups.push(groupInfo);
                                    }
                                }
                            }
                        }
                        self.groups = Utils.merge([], newGroups);

                        self.getMerchtTplRoleDevcGroupList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            handleCheckAllChange: function (checked) {
                let groupIds = [];
                if(checked) {
                    this.groups.forEach(function (itemInfo) {
                        itemInfo.subGroups.forEach(function (item) {
                            groupIds.push(item.id);
                        });
                    });
                }
                this.isIndeterminate = false;
                this.groupIds = Utils.merge([], groupIds);
            },
            handleCheckedChange(value) {
                let checkedCount = value.length;
                let sumLength = 0;
                let groups = this.groups || [];
                for(let i = 0; i < groups.length; i++) {
                    sumLength += groups[i].subGroups.length || 0;
                }
                this.checked = checkedCount >= sumLength;
                this.isIndeterminate = checkedCount > 0 && checkedCount < sumLength;
            },
            updateComRole(){
                let self = this;
                let groupIds = this.groupIds;
                let postData = {
                    tplRoleId: self.roleId,
                    groupIds: groupIds
                };
                let loading = MsgBox.loading();
                merchtAllApi.saveMerchtTplRoleDevcGroup(postData, function (result) {
                    loading.hide();
                    if(result.type == "info") {
                        self.$message.success("操作成功");
                        self.getMerchtTplRoleDevcGroupList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/authx/MerchtTplRoleDevcGroup.vue